module.exports = __webpack_public_path__ + "media/unipod/live_testing-cd7ec932.jpg";